import { useState } from 'react';
import {
  AppBar,
  Box,
  Button,
  Container,
  Drawer,
  IconButton,
  List,
  ListItemButton,
  ListItemText,
  Toolbar,
  Typography,
} from '@mui/material';
import MenuRoundedIcon from '@mui/icons-material/MenuRounded';
import { Link, NavLink } from 'react-router-dom';

const navigation = [
  { label: 'Transmembrane Focus', to: '/transmembrane' },
  { label: 'All genes', to: '/all-genes?method=deseq2&direction=up&scope=all' },
  { label: 'Methods', to: '/methods' },
  { label: 'Help & support', to: '/help' },
];

function navSx({ isActive }) {
  return {
    color: isActive ? 'primary.dark' : 'text.secondary',
    bgcolor: isActive ? 'primary.light' : 'transparent',
    '&:hover': { bgcolor: 'primary.light', color: 'primary.dark' },
  };
}

export default function SiteHeader() {
  const [drawerOpen, setDrawerOpen] = useState(false);

  return (
    <AppBar
      position="sticky"
      color="inherit"
      elevation={0}
      sx={{ borderBottom: '1px solid', borderColor: 'divider', bgcolor: 'rgba(255,255,255,0.96)' }}
    >
      <Container maxWidth="xl">
        <Toolbar disableGutters sx={{ minHeight: { xs: 68, md: 76 }, gap: 2 }}>
          <Box
            component={Link}
            to="/"
            aria-label="Brendo home"
            sx={{ display: 'flex', alignItems: 'center', color: 'inherit', textDecoration: 'none' }}
          >
            <Box
              component="img"
              src="/images/mustafaoglu-mark.png"
              alt=""
              aria-hidden="true"
              sx={{ width: 34, height: 34, objectFit: 'contain', flexShrink: 0, mr: 1.25 }}
            />
            <Box>
              <Typography component="span" sx={{ display: 'block', fontWeight: 800, fontSize: '1.28rem', lineHeight: 1.05 }}>
                Brendo
              </Typography>
              <Typography component="span" variant="caption" color="text.secondary" sx={{ display: { xs: 'none', sm: 'block' } }}>
                Brain Endothelial Open Resource
              </Typography>
            </Box>
          </Box>

          <Box component="nav" aria-label="Primary navigation" sx={{ display: { xs: 'none', md: 'flex' }, gap: 0.5, ml: 'auto' }}>
            {navigation.map((item) => (
              <Button key={item.to} component={NavLink} to={item.to} sx={navSx}>
                {item.label}
              </Button>
            ))}
          </Box>

          <IconButton
            aria-label="Open navigation menu"
            onClick={() => setDrawerOpen(true)}
            sx={{ display: { md: 'none' }, ml: 'auto' }}
          >
            <MenuRoundedIcon />
          </IconButton>
        </Toolbar>
      </Container>

      <Drawer anchor="right" open={drawerOpen} onClose={() => setDrawerOpen(false)}>
        <Box component="nav" aria-label="Mobile navigation" sx={{ width: 290, p: 2 }}>
          <Typography sx={{ fontWeight: 800, px: 2, py: 1.5 }}>Brendo</Typography>
          <List>
            <ListItemButton component={NavLink} to="/" onClick={() => setDrawerOpen(false)}>
              <ListItemText primary="Home" />
            </ListItemButton>
            {navigation.map((item) => (
              <ListItemButton key={item.to} component={NavLink} to={item.to} onClick={() => setDrawerOpen(false)}>
                <ListItemText primary={item.label} />
              </ListItemButton>
            ))}
          </List>
        </Box>
      </Drawer>
    </AppBar>
  );
}
